export const findShapesModelFactory = require('!carmi/loader?compiler=simple&no-cache=true!../findShapes/carmi/findShapes.carmi')
